import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarDoors,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import StockFilterRange from '@/components/StockFilterRange';

function DoorsFilter() {
  const dispatch = useTypedDispatch();
  const selectedDoors =
    useTypedSelector(getSelectedFilters).selectedParams.selectedDoors;

  const handleBlurDoors = (doors: RangeType) => {
    dispatch(setCarDoors(doors));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Количество дверей"
        values={selectedDoors}
        onBlur={handleBlurDoors}
      />
    </MobileFilterWrapper>
  );
}

export default DoorsFilter;
